import React from "react";
import banner1 from "../../images/AdsBanner/banner1.webp";
import banner2 from "../../images/AdsBanner/banner2.webp";
import banner3 from "../../images/AdsBanner/banner3.webp";
import banner4 from "../../images/AdsBanner/banner4.jpg";

const AdsBannerSection = () => {
  return (
    <section className="container mt-4 mb-3">
      <div className="row">
        <div className="col-md-12 col-12">
          <div className="bigAdBanner-container">
            <img className="big-banner-image" src={banner4} alt="banner1" />
          </div>
        </div>
        {/* <div className="col-md-4 col-12">
          <div className="smlAdBanner-container mb-4">
            <img className="sml-banner-image" src={banner2} alt="banner2" />
          </div>
          <div className="smlAdBanner-container smlAdBanner">
            <img className="sml-banner-image" src={banner3} alt="banner3" />
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default AdsBannerSection;
